import React from "react";

import { Column } from "Components/AppGrid/shipeezi-new-grid";
import BadgeStatus from "Components/Generic/BadgeStatus";
import { Location } from "Models/location";
import { Member } from "Models/members/member";
import { TFunction } from "react-i18next";
import { TypeOfMember } from "Util/enums/members";

interface GetMembersTableColumnsParams {
  translate: TFunction<"translation", undefined>;
}

export const getMembersTableColumns = (props: GetMembersTableColumnsParams) => {
  const { translate } = props;
  const columns: Column[] = [
    {
      name: "code",
      title: translate("code"),
      hideSearch: true,
      hideSort: true,
      formatComponent: (_value, row: Member) => {
        if (row?.userCompanyId) {
          return <span>{row?.userCompany?.code}</span>;
        }

        return "-";
      },
      pinned: true,
    },
    {
      name: "fullName",
      title: translate("name"),
      searchIdentifier: "full_name",
    },
    {
      name: "email",
      title: translate("email"),
    },
    {
      name: "typeOfMember",
      hideSearch: true,
      hideSort: true,
      title: translate("typeOfMember"),
    },
    {
      name: "typeOfUser",
      hideSearch: true,
      hideSort: true,
      title: translate("typeOfUser"),
      formatComponent: (_, row: Member) => {
        if (row?.typeOfMember === TypeOfMember.USER) {
          return row?.userCompany?.typeUser || "-";
        }

        return "-";
      },
    },
    {
      name: "role",
      hideSearch: true,
      hideSort: true,
      title: translate("role"),
      formatComponent: (_value, row: Member) => {
        if (row?.typeOfMember === TypeOfMember.USER) {
          return row?.userCompany?.role?.name || "-";
        }

        return "-";
      },
    },
    {
      name: "location",
      hideSearch: true,
      hideSort: true,
      title: translate("location"),
      formatComponent: (value: Location) => {
        if (value) {
          return `${value.longAddress ?? ""}`;
        }

        return "-";
      },
    },
    {
      name: "userCompany",
      hideSearch: true,
      hideSort: true,
      title: translate("accessTo"),
      formatComponent: (_value, row: Member) => {
        if (row?.typeOfMember === TypeOfMember.USER && row?.userCompany?.applications?.length) {
          return row?.userCompany?.applications?.map((application) => application.name).join(", ");
        }

        return "-";
      },
    },
    {
      name: "status",
      title: translate("status"),
      hideSearch: true,
      formatComponent: (status: string) => <BadgeStatus value={status} />,
      hideSort: true,
    },
  ];

  return columns;
};
